export default {
  PL: {
    PRODUCTION: "https://strefa.tms.pl",
    TEST: "https://master-strefa.test.tms.pl",
  },
  OANDA: {
    PRODUCTION: "https://www.oanda.com/",
    STAGE: "https://www-stg.stage.oanda.com/",
    TEST: "https://master-clientzone.test.tms.pl/",
  },
  OTHERS: {
    PRODUCTION: "https://client.tmsbrokers.com/",
    STAGE: "https://master-clientzone.test.tms.pl/",
    TEST: "https://master-clientzone.test.tms.pl/",
  },
};
